<script lang="ts" setup>
import { Check, X } from 'lucide-vue-next';
import { defineProps } from 'vue';

const props = defineProps<{
  value?: boolean
}>()
</script>
<template>
  <span class="inline-block">
    <Check v-if="props.value" :size="18" :color="'green'" />
    <X v-else :size="16" />
  </span>
</template>
